module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Dedications")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("From Becky")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("I believe that you really can learn something new every day. To do that you must let yourself be open to new ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When presented with a new way to do something, it is easy to let your first thought be, “No, I do it "), _c('em', [_vm._v("this")]), _vm._v(" way.” I have been guilty of that myself. However, in the last few years I have made a concerted effort to be more open to new ideas. As a consequence, I have learned some new things (not all of them appliqué related).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I dedicate this book to the spirit of open-mindedness and sharing that is such an important part of every quilter’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("From Linda")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("My niece Magen is a marine biologist. She has a love for new adventures, like swimming with the whales, dolphins, and sharks (small, well-fed sharks). Magen loves the outdoors, hiking, rock climbing, being with the crew on a tall ship, and more. For the last few years Magen has worked on Catalina Island, teaching children about marine life.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I asked her once where this love of the outdoors came from. She looked at me and said, “Aunt Linda, you have been taking me hiking since I was five.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I dedicate this book to everyone who loves a new adventure. Not all adventures have to be outside. I hope you will have many wonderful hours with the adventure of needle-turn appliqué in this book.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7d8411e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781607054726_03_ded.vue
// module id = 63
// module chunks = 0